import * as React from "react";
const SvgCheckboxMark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 15, viewBox: "0 0 21 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.695312 8.15883L6.71228 14.1755L19.9588 0.929199", strokeMiterlimit: 16 }));
export default SvgCheckboxMark;
